<template>
  <div v-if="messages && messages.length > 0" v-cloak>
    <transition name="modal">
      <div class="modal-mask" v-cloak>
        <div class="container">
          <div class="modal-wrapper" v-cloak>
            <message
              v-if="messagesCount"
              :message="message"
              :index="messageIndex"
              @dismiss="dismissMessage"
              v-cloak
            ></message>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
import _ from "lodash";
import Message from "./Message";
import { mapState } from "vuex";

export default {
  name: "message-center",
  components: {
    Message
  },
  computed: {
    messagesCount() {
      return this.messages.length;
    },
    message() {
      if (this.messagesCount === 0) return null;
      return this.messages[this.messagesCount - 1];
    },
    messageIndex() {
      if (this.messagesCount === 0) return null;
      return this.messagesCount - 1;
    },
    ...mapState({
      messages: state => state.messages
    })
  },
  methods: {
    dismissMessage() {
      this.$store.commit("dismissMessage");
    }
  }
};
</script>
<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  transition: opacity 0.3s ease;
}
.modal-mask .container {
  height: 100%;
  position: relative;
  display: table;
}

.modal-mask .container .close {
  position: absolute;
  top: 22px;
  right: 30px;
  opacity: 1;
  font-size: 66px;
  font-weight: lighter;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}
</style>
